import { api } from '@smena/ui';

/**
 * Платформенные настройки Telegram (SOCKS5-прокси). Правит вендор, не УК: Telegram
 * заблокирован в РФ, поэтому прокси - условие работы платформы, а не выбор клиента.
 *
 * Полного URL здесь нет и не будет: в нём логин и пароль. Сервер отдаёт только метку
 * socks5://user:***@host:port - её хватает, чтобы опознать адрес, и не хватает,
 * чтобы им воспользоваться.
 */
export interface TelegramSettingsView {
  proxyEnabled: boolean;
  hasProxyUrl: boolean;
  proxyLabel: string | null;
  updatedAt: string | null;
  updatedBy: string | null;
  updatedByEmail: string | null;
}

export interface SaveTelegramInput {
  proxyEnabled?: boolean;
  /** Пусто или отсутствует - не менять адрес. Явный null - удалить сохранённый. */
  proxyUrl?: string | null;
}

export function fetchTelegramSettings(): Promise<TelegramSettingsView> {
  return api<TelegramSettingsView>('/api/admin/telegram');
}

// `json:`, а не `body: JSON.stringify(...)` - хелпер ставит Content-Type только в первом
// варианте, иначе Nest получит text/plain и разберёт тело как пустое.
export function saveTelegramSettings(input: SaveTelegramInput): Promise<TelegramSettingsView> {
  return api<TelegramSettingsView>('/api/admin/telegram', { method: 'PUT', json: input });
}
